import {FixedFooter} from 'components/common/FixedFooter'
import {Button} from 'components/system/Button'
import {useCurrency, useTravelerPath} from 'providers/EnvironmentProvider'
import {OrderProvider} from 'providers/OrderProvider'
import {useCallback} from 'react'
import {formatMoney} from 'utils/formatMoney'

export const Total = () => {
  const currency = useCurrency()
  const order = OrderProvider.useOrder()
  const travelerPath = useTravelerPath()

  const showCheckout = useCallback(() => {
    window.location.href = travelerPath
  }, [travelerPath])

  return (
    <div className="bg-white p-4 flex flex-col gap-2 rounded-lg">
      <div className="font-bold text-xl">Subtotal</div>
      <div className="flex justify-between">
        <div>{order.bookings.length} items</div>
        <div className="font-bold text-lg">
          {formatMoney(order.pricing?.original || 0, order.pricing?.currency || currency)}
        </div>
      </div>
      <FixedFooter>
        <Button.Primary.Orange onClick={showCheckout} expanded>
          Go to checkout
        </Button.Primary.Orange>
      </FixedFooter>
    </div>
  )
}
